import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const number = process.env.REACT_APP_WHATSAPP_NUMBER;
  if (!number) return null;
  const href = `https://wa.me/${number}?text=${encodeURIComponent(
    "Hello STAR AVG ENTERPRISE, I'd like to discuss an interior project."
  )}`;
  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-chat-button"
      aria-label="Chat with us on WhatsApp"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2.2, duration: 0.5 }}
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-ink text-paper transition-colors duration-300 hover:bg-clay hover:text-ink"
    >
      <MessageCircle size={22} />
    </motion.a>
  );
}
